export const ACTIONS = {
  CHANGE_LANGUAGE: 'locale/change_language',
};

const changeLanguage = locale => ({ type: ACTIONS.CHANGE_LANGUAGE, payload: locale });

export const changeLanguageToSpanish = () => changeLanguage('es');

export const changeLanguageToEnglish = () => changeLanguage('en');
